import { useRef } from "react";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">
        <Banner
          config={{
            applyFormRef: applyFormRef,
            title: "Flutter Mobile App Developer",
          }}
        />

        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            
            <div className="lg:col-span-2 space-y-12">
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  We are looking for a talented and passionate Flutter Developer
                  to join our team. The ideal candidate will be responsible for
                  developing high-performance mobile applications for both
                  Android and iOS platforms using Flutter. You will work closely
                  with UI/UX designers and backend developers to deliver
                  seamless user experiences.
                </p>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Key Responsibilities
                </h3>

                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>Design and build advanced mobile applications using Flutter.</li>
                  <li>
                    Collaborate with cross-functional teams to define, design,
                    and ship new features.
                  </li>
                  <li>
                    Ensure the performance, quality, and responsiveness of
                    applications.
                  </li>
                  <li>Maintain code quality, organization, and automation.</li>
                  <li>Fix bugs and improve application performance.</li>
                  <li>
                    Stay up-to-date with new trends and technologies in mobile
                    app development.
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Requirements
                </h3>

                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>Proficient in Flutter and Dart programming language.</li>
                  <li>Experience in mobile app development for iOS and Android.</li>
                  <li>
                    Familiarity with RESTful APIs and integration with backend services.
                  </li>
                  <li>
                    Knowledge of Firebase (Authentication, Cloud Firestore, Push Notifications).
                  </li>
                  <li>Strong understanding of mobile UI/UX principles.</li>
                  <li>Experience with version control tools like Git.</li>
                  <li>Good problem-solving and debugging skills.</li>
                </ul>
              </div>
            </div>

            <JobInformation />
          </div>
        </div>
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
